import create from "vue-zustand";

const initialState = localStorage.getItem("productState") ? JSON.parse(localStorage.getItem("productState")) : {};

export const useBillingStore = create(() => initialState);
